import text from './en';

export const lang = 'en';

export default text;
